module.exports = __webpack_public_path__ + "media/images/scroll-left-f8876fef.svg";